import React, { Component } from 'react'
import { RiDeleteBin7Line } from 'react-icons/ri'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import BackButton from '../../../elements/BackButton'
import img from "../../../assets/Images/exam.png";
import { getAllOnlineExam } from "../../../redux/Teacher/onlineTest/action"
import moment from "moment"
import { Button } from 'react-bootstrap'
import ContentLoader from 'react-content-loader'
export class TeacherAllOnlineTest extends Component {
    state = {
        loading: false,
    }
    componentDidMount() {
        const { user } = this.props;
        this.setState({ loading: true });
        this.props.getAllOnlineExam(user?.data?.auth_token).then(() => {
            this.setState({ loading: false });
        }).catch(() => {
            this.setState({ loading: false });
        });
    }

    isTestCompleted = (exam) => {
        if (!exam || !exam.exam_date) return false;
        const examDate = moment(exam.exam_date);
        return examDate.isBefore(moment(), 'day') || (exam.results && exam.results.length > 0);
    }

    render() {
        const { exams } = this.props;
        const examList = exams?.data || (Array.isArray(exams) ? exams : []);

        return (
            <React.Fragment>
                {this.state.loading ? (
                    <React.Fragment>
                        <ContentLoader
                            viewBox="-2 0 280 580"
                            backgroundColor={"#F3F3F3"}
                            foregroundColor={"#ecebeb"}
                        >
                           <rect x="3" y="30" rx="10" ry="10" width="270" height="140" />
                           <rect x="3" y="180" rx="10" ry="10" width="270" height="140" />
                           <rect x="3" y="330" rx="10" ry="10" width="270" height="140" />
                           <rect x="3" y="520" rx="10" ry="10" width="270" height="50" />
                        </ContentLoader>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <BackButton title={"Online Test"} />
                        {examList.length > 0 ? (
                            <div className='mt-3 px-3' style={{ paddingBottom: "15vh" }}>
                                {examList.map((exam) => {
                                    const completed = this.isTestCompleted(exam);
                                    const className = exam?.class?.name ? `${exam.class.name}${exam.section?.name ? ' - ' + exam.section.name : ''}` : 'N/A';

                                    return (
                                        <div key={exam.id}>
                                            <div className='d-flex flex-column px-3 py-2 position-relative mt-3' style={{ backgroundColor: '#f4f4f4', borderRadius: '12px' }}>
                                                <div className='d-flex justify-content-between align-items-center mt-1'>
                                                    <div style={{ color: '#b3b3b3' }}>
                                                        Exam Name : <span className='fw-bolder text-muted'>{exam?.name || 'Untitled Exam'}</span>
                                                    </div>
                                                    <span className={`badge ${completed ? 'bg-success' : 'bg-primary'} px-2 py-1`} style={{ fontSize: '11px' }}>
                                                        {completed ? 'Completed' : 'Upcoming'}
                                                    </span>
                                                </div>
                                                <div className='mt-1' style={{ color: '#b3b3b3' }}>Subject : <span className='fw-bolder text-muted'>{exam?.subject?.name || 'N/A'}</span></div>
                                                <div className='mt-1' style={{ color: '#b3b3b3' }}>Class : <span className='fw-bolder text-muted'>{className}</span></div>
                                                <div className='mt-1' style={{ color: '#b3b3b3' }}>Term : <span className='fw-bolder text-muted' style={{ color: '#72AFBC' }}>{exam?.term?.name || 'N/A'}</span></div>
                                                <div className='mt-1' style={{ color: '#b3b3b3' }}>Starts at : <span className='fw-bolder text-muted'>{exam?.from_time ? moment(new Date("1970-01-02T" + exam.from_time).getTime()).format('LT') : ''} {exam?.exam_date ? moment(exam.exam_date).format('YYYY-MM-DD') : ''}</span></div>

                                                <div className="d-flex align-items-center justify-content-between mt-3">
                                                    <Link to={"/teacher-single-test/" + exam.id}>
                                                        <button className='p-1 px-2' style={{
                                                            all: "unset",
                                                            background: "#DBEAFF",
                                                            color: '#0D6EFD',
                                                            borderRadius: "5px",
                                                            fontSize: '12px',
                                                            fontWeight: '600'
                                                        }}>View Questions</button>
                                                    </Link>

                                                    <Link to={"/student-test-answer/" + exam.id}>
                                                        <button className='text-white bg-primary p-1 px-2' style={{
                                                            all: "unset",
                                                            borderRadius: "5px",
                                                            fontSize: '12px',
                                                            fontWeight: '600'
                                                        }}>View Marks & Results</button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="d-flex flex-column align-items-center justify-content-center mt-5 appointment-no-data px-3" style={{ height: "50vh" }}>
                                <img src={img} alt="no_test" style={{ width: "100%" }} />
                                <div className="fs-5 fw-500">No Online Tests Found</div>
                            </div>
                        )}
                        <div className='position-fixed bottom-0 py-2 w-100 px-3'>
                            <Link to="/create-online-test">
                                <button className='btn attendence-dwld-btn mt-2 py-3 w-100'>
                                    Create Online Test
                                </button>
                            </Link>
                        </div>
                    </React.Fragment>
                )}
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    user: state.teacher.teacher,
    exams: state.onlineExam.allOnlineExam
})


export default connect(mapStateToProps, { getAllOnlineExam })(TeacherAllOnlineTest)
